export const COMPENSATION = 'COMPENSATION';
export const PENALIZATION = 'PENALIZATION';
